import { useEffect, useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import analytics, { trackPageView, trackUserAction, trackEvent } from '../utils/analytics';

export const useAnalytics = () => {
  const location = useLocation();

  // Track page views on route changes
  useEffect(() => {
    trackPageView(location.pathname);
  }, [location.pathname]);

  // Enhanced tracking functions
  const trackLinkClick = useCallback((href, text) => {
    trackUserAction('link_click', {
      href,
      text: text?.substring(0, 100),
      external: href.startsWith('http'),
      page: location.pathname
    });
  }, [location.pathname]);

  const trackDownload = useCallback((filename, type = 'unknown') => {
    trackUserAction('file_download', {
      filename,
      type,
      page: location.pathname
    });
  }, [location.pathname]);

  const trackResumeView = useCallback((version) => {
    trackUserAction('resume_view', {
      version,
      page: location.pathname
    });
  }, [location.pathname]);

  const trackSocialClick = useCallback((platform, action = 'click') => {
    trackUserAction('social_interaction', {
      platform,
      action,
      page: location.pathname
    });
  }, [location.pathname]);

  const trackContactAttempt = useCallback((method, details = {}) => {
    trackUserAction('contact_attempt', {
      method,
      page: location.pathname,
      ...details
    });
  }, [location.pathname]);

  const trackProjectInteraction = useCallback((projectName, action) => {
    trackUserAction('project_interaction', {
      projectName,
      action,
      page: location.pathname
    });
  }, [location.pathname]);

  return {
    trackLinkClick,
    trackDownload,
    trackResumeView,
    trackSocialClick,
    trackContactAttempt,
    trackProjectInteraction,
    trackEvent,
    getUserProfile: () => analytics.getUserProfile(),
    getDetailedStats: () => analytics.getDetailedStats()
  };
}; 